"use client";

import { Modal } from "@/components/Modal";
import { SearchInput } from "@/components/SearchInput";
import { CategoryControl } from "@/components/selectArtistModal/categoryControl/CategoryControl";
import { InstrumentsTab } from "@/components/selectArtistModal/InstrumentsTab";
import { MixedTab } from "@/components/selectArtistModal/MixedTab";
import { MyTab } from "@/components/selectArtistModal/MyTab";
import { RoyaltyFreeTab } from "@/components/selectArtistModal/royaltyFreeTab/RoyaltyFreeTab";
import { SavedTab } from "@/components/selectArtistModal/savedTab/SavedTab";
import { useNamedSelectArtistFilters } from "@/lib/zustand/useSelectArtistFilters";
import {
  ArtistInstumentSaved,
  MixedModelConstructedNoDates,
  ModelNoDates,
  UserNoDates,
} from "@/types/types";

export function SelectArtistModal({
  open,
  closeModal,
  user,
  models,
  mixedModelsConstructed,
  handleClickArtist,
  savedArtistsInstrumentsIds,
  showMixedModelTab,
  namespace,
  popularityByArtistId,
}: {
  open: boolean;
  closeModal: () => void;
  user: UserNoDates | null;
  models: ModelNoDates[] | null;
  mixedModelsConstructed: MixedModelConstructedNoDates[] | null;
  handleClickArtist: (artistId: string) => void;
  savedArtistsInstrumentsIds: ArtistInstumentSaved["artistInstrumentId"][];
  showMixedModelTab: boolean;
  namespace: string;
  popularityByArtistId: Record<string, number> | null;
}) {
  const useSelectArtistFilters = useNamedSelectArtistFilters((state) =>
    state.getNamedStore(namespace)
  );
  const categoryShow = useSelectArtistFilters((state) => state.categoryShow);
  const searchString = useSelectArtistFilters((state) => state.searchString);
  const setSearchStringStore = useSelectArtistFilters(
    (state) => state.setSearchString
  );

  // Filter in the confirmed done models and mixed models
  let confirmedDoneModels: ModelNoDates[] | null = null;
  if (models !== null) {
    confirmedDoneModels = models.filter((model) => model.confirmedDone);
  }

  let confirmedDoneMixedModels: MixedModelConstructedNoDates[] | null = null;
  if (mixedModelsConstructed !== null) {
    confirmedDoneMixedModels = mixedModelsConstructed.filter(
      (model) => model.confirmedDone
    );
  }

  return (
    <Modal
      open={open}
      closeModal={closeModal}
      title="Select voice"
      widthMode="ultraWide"
      minFullHeight={true}
    >
      <div>
        <CategoryControl
          namespace={namespace}
          className="mb-4"
          showMixedModelTab={showMixedModelTab}
        />

        <SearchInput
          searchString={searchString}
          setSearchString={setSearchStringStore}
          placeholder="Search by name or tag…"
          small={true}
          open={open}
          className="mb-4"
        />

        {categoryShow === "Royalty-free" && (
          <RoyaltyFreeTab
            namespace={namespace}
            handleClickArtist={handleClickArtist}
            closeModal={closeModal}
            user={user}
            savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
            popularityByArtistId={popularityByArtistId}
          />
        )}
        {categoryShow === "Saved" && (
          <SavedTab
            handleClickArtist={handleClickArtist}
            closeModal={closeModal}
            user={user}
            confirmedDoneModels={confirmedDoneModels}
            confirmedDoneMixedModels={confirmedDoneMixedModels}
            savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
            namespace={namespace}
          />
        )}
        {categoryShow === "Instruments" && (
          <InstrumentsTab
            handleClickArtist={handleClickArtist}
            closeModal={closeModal}
            user={user}
            savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
            namespace={namespace}
          />
        )}
        {categoryShow === "My" && (
          <MyTab
            confirmedDoneModels={confirmedDoneModels}
            handleClickArtist={handleClickArtist}
            closeModal={closeModal}
            user={user}
            savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
            namespace={namespace}
          />
        )}
        {showMixedModelTab && categoryShow === "Mixed" && (
          <MixedTab
            confirmedDoneMixedModels={confirmedDoneMixedModels}
            handleClickArtist={handleClickArtist}
            closeModal={closeModal}
            user={user}
            savedArtistsInstrumentsIds={savedArtistsInstrumentsIds}
            namespace={namespace}
          />
        )}
      </div>
    </Modal>
  );
}
